export default __webpack_public_path__ + "static/media/audubon-ia.187ff3a5.webp";